const isProduction = process.env.NODE_ENV === 'production';

export const logger = {
  debug: (message: string, ...args: unknown[]) => {
    if (!isProduction) {
      console.debug(`[DEBUG] ${message}`, ...args);
    }
  },

  log: (message: string, ...args: unknown[]) => {
    console.log(`[LOG] ${message}`, ...args);
  },

  info: (message: string, ...args: unknown[]) => {
    console.info(`[INFO] ${message}`, ...args);
  },

  warn: (message: string, ...args: unknown[]) => {
    console.warn(`[WARN] ${message}`, ...args);
  },

  error: (message: string, error?: Error | unknown, ...args: unknown[]) => {
    if (error instanceof Error) {
      console.error(`[ERROR] ${message}`, error.message, ...args);
    } else {
      console.error(`[ERROR] ${message}`, error, ...args);
    }
  },
};
